import { render, staticRenderFns } from "./Recordings.vue?vue&type=template&id=9bd6d6d2&scoped=true&"
import script from "./Recordings.vue?vue&type=script&lang=js&"
export * from "./Recordings.vue?vue&type=script&lang=js&"
import style0 from "./Recordings.vue?vue&type=style&index=0&id=9bd6d6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd6d6d2",
  null
  
)

export default component.exports